import config from '@/config'
import Comments, { IComments } from '@/models/Comments'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)
export default class CommentsService extends BaseService<Comments> {
  protected basePath = ''
  readonly groupId: string

  model(): typeof Comments {
    return Comments
  }

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.groupId = groupId
    this.basePath = `/${locationId}/groups/${groupId}`
  }

  async create(data: IComments): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/posts/${data.postId}/comments`,
      data
    )
    return response?.data
  }

  async updateComment(
    commentData: IComments,
    postId: string,
    commentId: string
  ): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/posts/${postId}/comments/${commentId}`,
      {
        action: 'UPDATE_COMMENT',
        comment: commentData,
      }
    )
    return response.data
  }

  async fetchComments(postId: string, query?: any): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/posts/${postId}/comments`,
      { params: query }
    )
    return response.data
  }

  async fetchCommentById(postId: string, commentId: string): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/posts/${postId}/comments/${commentId}`
    )
    return response.data
  }

  async deleteComment(
    commentId: string,
    postId: string,
    parentId?: string
  ): Promise<any> {
    const response = await http.delete(
      `${this.endpoint}/posts/${postId}/comments/${commentId}`,
      {
        params: {
          parentId: parentId,
        },
      }
    )
    return response.data
  }
}
